import type { WHITEBOARD_ENTRYPOINT_EXPERIMENT_VARIANTS } from '../../../view/whiteboards-entrypoint-experiment/constants.tsx';

export const CONFLUENCE_ACCESS_ESTABLISHED =
	'state.actions.permissions.CONFLUENCE_ACCESS_ESTABLISHED' as const;

export type HasConfluenceAccessEstablishedAction = {
	type: typeof CONFLUENCE_ACCESS_ESTABLISHED;
	payload: {
		hasConfluenceAccess: boolean;
	};
};

export const hasConfluenceAccessEstablished = (
	hasConfluenceAccess: boolean,
): HasConfluenceAccessEstablishedAction => ({
	type: CONFLUENCE_ACCESS_ESTABLISHED,
	payload: {
		hasConfluenceAccess,
	},
});

export const HAS_CONFLUENCE_SPACES = 'state.actions.HAS_CONFLUENCE_SPACES' as const;

export type HasConfluenceSpacesEstablishedAction = {
	type: typeof HAS_CONFLUENCE_SPACES;
	payload: {
		hasConfluenceSpaces: boolean;
	};
};

export const hasConfluenceSpacesEstablished = (
	hasConfluenceSpaces: boolean,
): HasConfluenceSpacesEstablishedAction => ({
	type: HAS_CONFLUENCE_SPACES,
	payload: {
		hasConfluenceSpaces,
	},
});

export const SET_WHITEBOARD_ELIGIBILITY =
	'state.actions.permissions.SET_WHITEBOARD_ELIGIBILITY' as const;

export type SetWhiteboardEligibilityAction = {
	type: typeof SET_WHITEBOARD_ELIGIBILITY;
	payload: {
		flow: 'coUse' | 'crossFlow';
		cohort: WHITEBOARD_ENTRYPOINT_EXPERIMENT_VARIANTS | string;
	};
};

export const setWhiteboardEligibility = ({
	flow,
	cohort,
}: {
	flow: 'coUse' | 'crossFlow';
	cohort: WHITEBOARD_ENTRYPOINT_EXPERIMENT_VARIANTS | string;
}): SetWhiteboardEligibilityAction => ({
	type: SET_WHITEBOARD_ELIGIBILITY,
	payload: {
		flow,
		cohort,
	},
});

export const HAS_XFLOW_FROM_WHITEBOARDS_TOUCHPOINT =
	'state.actions.permissions.HAS_CROSS_FLOWED_FROM_WHITEBOARDS' as const;

export type HasXFlowFromWhiteboardsTouchpointAction = {
	type: typeof HAS_XFLOW_FROM_WHITEBOARDS_TOUCHPOINT;
	payload: {
		hasXflowFromWhiteboardsTouchpoint: boolean;
	};
};

export const setHasXflowFromWhiteboardsTouchpoint = (
	hasXflowFromWhiteboardsTouchpoint: boolean,
): HasXFlowFromWhiteboardsTouchpointAction => ({
	type: HAS_XFLOW_FROM_WHITEBOARDS_TOUCHPOINT,
	payload: {
		hasXflowFromWhiteboardsTouchpoint,
	},
});

export const SET_USER_PROPERTY_KEYS = 'state.actions.permissions.SET_USER_PROPERTY_KEYS' as const;

export type SetUserPropertyKeysAction = {
	type: typeof SET_USER_PROPERTY_KEYS;
	payload: string[];
};

export const setUserPropertyKeys = (payload: string[]): SetUserPropertyKeysAction => ({
	type: SET_USER_PROPERTY_KEYS,
	payload,
});

export const SET_USER_PROPERTY_KEY = 'state.actions.permissions.SET_USER_PROPERTY_KEY' as const;

export type SetUserPropertyKeyAction = {
	type: typeof SET_USER_PROPERTY_KEY;
	payload: string;
};

export const setUserPropertyKey = (payload: string): SetUserPropertyKeyAction => ({
	type: SET_USER_PROPERTY_KEY,
	payload,
});

export type Action =
	| HasConfluenceAccessEstablishedAction
	| HasConfluenceSpacesEstablishedAction
	| SetWhiteboardEligibilityAction
	| HasXFlowFromWhiteboardsTouchpointAction
	| SetUserPropertyKeyAction
	| SetUserPropertyKeysAction;
